import React from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import { CM2Dataset } from '@interfaces/central-monitoring';
import { DummyPanelFrame } from '@pages-clean/dummy-page/pages/data-view-config-poc/dummy-panel-frame';
import { FilterButton } from '@pages-clean/dummy-page/pages/data-view-config-poc/filter-button';
import { PanelData } from '@pages-clean/dummy-page/pages/data-view-config-poc/types';

type DataViewConfigPoCProps = {
    studyId: string;
    panelData: PanelData[];
    dataViewConfigId: string;
    dataset: CM2Dataset;
};

export const DataViewConfigPoC = ({ studyId, panelData, dataViewConfigId, dataset }: DataViewConfigPoCProps) => {
    return (
        <div className="k-d-flex k-flex-col k-gap-2">
            <FilterButton studyId={studyId} dataset={dataset} dataViewConfigId={dataViewConfigId} />
            {!!panelData.length && (
                <div className="k-d-flex k-gap-2 k-flex-row k-flex-wrap">
                    {panelData.map((p) => (
                        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
                        // eslint-disable-next-line @eslint-react/no-missing-key
                        <div className={cn(styles.panel, 'k-flex-auto')}>
                            <DummyPanelFrame
                                key={p.id}
                                studyRef={studyId}
                                dataset={dataset}
                                panelRef={p.id}
                                dataViewRef={dataViewConfigId}
                                graphType={p.type}
                                modelType={p.modelType}
                                panelType={p.panelType}
                                theme={p.theme}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
